export default "/images/vendor/flag-icon-css/flags/1x1/yt.svg?023b75b96409f72a6a3015db472b3b20";